import { gql } from '@apollo/client'
import { Fragments } from '../fragments'

export const fetchAllUsersQuery = gql`
  query FetchAllUsersQuery {
    self {
      id
    }

    allUsers {
      id
      name
      isClockedIn
      userType
      autoStationAssignmentEnabled
      unarchivedMessageCount
      oldestUnarchivedMessageTimeCreated

      ...LookingAtFragment

      mostRecentClockEvent {
        id
        clockInTime
        clockOutTime
      }

      activeOperatorShift {
        id
        shift {
          id
          timeStart
          timeEnd
        }
      }
    }
  }
  ${Fragments.lookingAtFragment}
`
